import 'angular';

import { UsersResolver } from './users.resolver.ajs';

angular.module('app-lite.users', [])
.run(UsersResolver);
